<template>
	<div class="title-list-sorting-switch__popover">
		<div
			v-for="item in showItems"
			:key="item.key"
			:class="{ 'title-list-sorting-switch__popover--selected': selectedItem?.key === item.key }"
			@click.prevent="changeSorting(item)"
		>
			<div class="vfm-item">
				{{ $t(item.translationKey) }}
				<FreemiumFilterBadge v-if="item.premium" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { SortingItem } from '@/helpers/list-sorting-helper';

import FreemiumFilterBadge from '@/components/filter-bar/FreemiumFilterBadge.vue';
import { ProModal } from '@/lazy-load-components';

import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { saveLastProView } from '@/helpers/pro-web-helper';
import { defaultSortingItemSelectedKeys, sortingItemsByCollectionType } from '@/helpers/list-sorting-helper';

import { useUserStore } from '@/stores/pinia/useUserStore';
import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';

import { computed } from 'vue';

const router = useRouter();

const filterStore = useFilterStore();
const routingStore = useRoutingStore();
const userStore = useUserStore();

const defaultSelectedKey = computed(() => defaultSortingItemSelectedKeys[routingStore.activeCollectionType!]);

const sortingItems = computed(() => sortingItemsByCollectionType[routingStore.activeCollectionType!]);

const selectedItem = computed(() => {
	const selectedKey = filterStore.currentFilters.sort_by ?? defaultSelectedKey.value;
	return sortingItems.value.find(item => item.key === selectedKey);
});
const emit = defineEmits(['dismiss']);

const showItems = computed(() => {
	if (!userStore.isPremium) {
		return sortingItems.value.filter(item => !item.premium);
	}

	return sortingItems.value;
});

async function changeSorting({ key, asc, premium }: SortingItem) {
	emit('dismiss');

	if (premium && !userStore.isPremium) {
		openPremiumModal();
	} else {
		const newRoute = filterStore.setListSorting({ sortBy: key, sortAsc: asc });
		if (newRoute) router.push(newRoute);
	}
}

function openPremiumModal() {
	ModalHelper.openModal(
		ProModal,
		{},
		{
			cssClass: 'pro-jw-pro-modal',
		},
		'SortRuntime',
		true
	);
	saveLastProView('SortRuntime');
}
</script>

<style lang="scss">
.title-list-sorting-switch {
	&__popover {
		&--selected {
			color: var(--jw-color-primary);

			.vfm-item {
				color: inherit !important;
			}
		}

		.vfm-item {
			padding: 14px;
			font-size: 16px;
			cursor: pointer;
		}
	}
}
</style>
